import {Link} from "react-router-dom";
import Slide6FWShort from "../../images/slider/slide-6-fw-short.jpg";
import Blank from "../../images/blank.png";

const BannerSection = () => (
    <div id="home" className="section-block featured-media tm-slider-parallax-container">
        <div className="tm-slider-container full-width-slider" data-featured-slider data-parallax
             data-parallax-fade-out data-animation="scaleIn" data-speed="1400" data-scale-under="960"
             data-scale-min-height="450">
            <ul className="tms-slides">
                <li className="tms-slide" data-video data-mute-video data-video-bkg-vimeo
                    data-overlay-bkg-color="#000000" data-overlay-bkg-opacity="0.4">
                    <div className="tms-content">
                        <div className="tms-content-inner center left-on-mobile v-align-middle">
                            <div className="row">
                                <div className="column width-8 offset-2">
                                    <h1 className="tms-caption weight-light color-white mb-5" data-no-scale
                                        data-animate-in="preset:slideInUpShort;duration:800ms;delay:100ms;">
                                        메타버스 기반 가상자산 커뮤니티
                                    </h1>
                                    <div className="clear"/>
                                    <h1 className="tms-caption weight-semi-bold color-white mb-40" data-no-scale
                                        data-animate-in="preset:slideInUpShort;duration:800ms;delay:600ms;">
                                        흑우촌
                                    </h1>
                                    <div className="clear"/>
                                    <Link to="/register"
                                          className="tms-caption button rounded large text-small text-uppercase shadow bkg-theme color-white bkg-hover-theme color-hover-white"
                                          data-animate-in="preset:slideInUpShort;duration:800ms;delay:1100ms;"
                                          data-no-scale>
                                        지금 시작하기
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <img data-src={Slide6FWShort} data-retina src={Blank} alt=""/>
                    <iframe width="2500" height="1600"
    src="https://player.vimeo.com/video/279969029?api=1"/>
                </li>
            </ul>
        </div>
    </div>
);

export default BannerSection;